import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useIvideon } from "./useIvideon";

export const useGetSubscriptionsList = () => {
  const { getSubscriptionsList } = useIvideon();
  const [subscriptionList, setSubscriptionList] = useState<{label:string, value:number}[]>();
  const [loading, setLoading] = useState(true);

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["ivideonSubscriptionsList"],
    queryFn: () => getSubscriptionsList(),
    refetchOnWindowFocus: false,
    enabled: true,
  });
  useEffect(() => {
    if (data?.data?.dealers && !isLoading) {
      let list = data?.data?.dealers.map(
        ({ id, name }: {id: number, name: string}) => {
          return {
            label: name,
            value: id,
          };
        },
      ).sort((a, b)=>a.label.localeCompare(b.label));
      setSubscriptionList(list);
      setLoading(isLoading);
    } else {
      setLoading(isLoading);
    }
  }, [data, isLoading]);

  return {
    data: subscriptionList ?? [],
    isLoading: loading,
    isError: isError,
    refetch: refetch,
  };
};
